<div class="breadcrumb" [class.wide-answer]="(report?.viewType === 'manager' || report?.showOrgComparison) && showOtherOrg">
  <a class="breadcrumb-link" (click)="onBack()">90秒アンケート</a>
  <span class="breadcrumb-sep">&gt;</span>
  <span class="breadcrumb-current">レポート</span>
</div>

@if (showSpinner) {
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
} @else if (report) {

  <h2 class="title" [class.wide-answer]="(report.viewType === 'manager' || report.showOrgComparison) && showOtherOrg">
    90秒アンケート レポート　<span class="title-month">{{ targetMonthLabel }}</span>
  </h2>

  <div class="stat-section" [class.wide-answer]="(report.viewType === 'manager' || report.showOrgComparison) && showOtherOrg">
    <div class="stat-heading-row">
      <h3 class="stat-heading">本人の状態（平均値）</h3>
    </div>
    <div class="stat-cards">
      <div class="stat-card">
        <div class="stat-card-label">{{ report.viewType === 'member' ? 'あなた' : '担当者' }}</div>
        <div class="stat-card-value">{{ report.selfStat.you != null ? (report.selfStat.you | number:'1.1-1') : '-' }}</div>
      </div>
      @if (report.viewType === 'manager' || report.showOrgComparison) {
        <div class="stat-card">
          <div class="stat-card-label">自組織</div>
          <div class="stat-card-value">{{ report.selfStat.org != null ? (report.selfStat.org | number:'1.1-1') : '-' }}</div>
        </div>
        @if (showOtherOrg) {
          <div class="stat-card">
            <div class="stat-card-label">他組織</div>
            <div class="stat-card-value">{{ report.selfStat.otherOrg != null ? (report.selfStat.otherOrg | number:'1.1-1') : '-' }}</div>
          </div>
        }
      }
      @if (report.viewType === 'manager' || report.showOrgComparison) {
        <div class="comparison-box">
          <div class="comparison-title">自組織との比較</div>
          @if (report.selfStat.comparison) {
            @for (c of report.selfStat.comparison; track c.no) {
              <div class="comparison-line">
                <span class="comparison-label">・{{ c.label }}</span>
                <span class="comparison-value">
                  <span class="comparison-num">{{ c.value | number:'1.1-1' }}</span>
                  <span class="comparison-diff" [class.plus]="c.diff >= 0" [class.minus]="c.diff < 0">
                    <span class="diff-sign">{{ c.diff >= 0 ? '+' : '-' }}</span><span class="diff-num">{{ (c.diff >= 0 ? c.diff : -c.diff) | number:'1.1-1' }}</span>
                  </span>
                </span>
              </div>
            }
          } @else {
            <div class="comparison-line">
              <span class="comparison-label">-</span>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <div class="stat-section" [class.wide-answer]="(report.viewType === 'manager' || report.showOrgComparison) && showOtherOrg">
    <div class="stat-heading-row">
      <h3 class="stat-heading">職場/店舗の状態（平均値）</h3>
      @if (report.viewType === 'member' && report.workplace) {
        <div class="workplace-line">
          回答した職場/店舗：{{ report.workplace.name }}
          @if (report.workplace.extra) { {{ report.workplace.extra }} }
        </div>
      }
    </div>

    <div class="stat-cards">
      <div class="stat-card">
        <div class="stat-card-label">{{ report.viewType === 'member' ? 'あなた' : '担当' }}</div>
        <div class="stat-card-value">{{ report.workplaceStat.you != null ? (report.workplaceStat.you | number:'1.1-1') : '-' }}</div>
      </div>
      <div class="stat-card">
        <div class="stat-card-label">自組織</div>
        <div class="stat-card-value">{{ report.workplaceStat.org != null ? (report.workplaceStat.org | number:'1.1-1') : '-' }}</div>
      </div>
      @if ((report.viewType === 'manager' || report.showOrgComparison) && showOtherOrg) {
        <div class="stat-card">
          <div class="stat-card-label">他組織</div>
          <div class="stat-card-value">{{ report.workplaceStat.otherOrg != null ? (report.workplaceStat.otherOrg | number:'1.1-1') : '-' }}</div>
        </div>
      }
      <div class="comparison-box">
        <div class="comparison-title">自組織との比較</div>
        @if (report.workplaceStat.comparison) {
          @for (c of report.workplaceStat.comparison; track c.no) {
            <div class="comparison-line">
              <span class="comparison-label">・{{ c.label }}</span>
              <span class="comparison-value">
                <span class="comparison-num">{{ c.value | number:'1.1-1' }}</span>
                <span class="comparison-diff" [class.plus]="c.diff >= 0" [class.minus]="c.diff < 0">
                    <span class="diff-sign">{{ c.diff >= 0 ? '+' : '-' }}</span><span class="diff-num">{{ (c.diff >= 0 ? c.diff : -c.diff) | number:'1.1-1' }}</span>
                  </span>
              </span>
            </div>
          }
        } @else {
          <div class="comparison-line">
            <span class="comparison-label">-</span>
          </div>
        }
      </div>
    </div>

    @if (report.viewType === 'manager' && report.workplaces) {
      <div class="workplaces-summary">
        <div class="workplaces-summary-block">
          <div class="workplaces-summary-title">
            <span>＜集計した職場/店舗＞　回答済：{{ report.workplaces.answeredCount }}</span>
            <span class="workplaces-summary-unanswered">未回答：{{ report.workplaces.unansweredAccountCount }}</span>
          </div>
          <div class="workplaces-summary-list">
            @for (wp of report.workplaces.answered; track $index) {
              <div class="workplaces-summary-line">
                ・{{ wp.name }}
                @if (wp.extra) { {{ wp.extra }} }
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>

  <ng-template #cellTpl let-cell="cell">
    @switch (cell.kind) {
      @case ('empty') {
        -
      }
      @case ('text') {
        {{ cell.text }}
      }
      @case ('list') {
        @for (item of cell.items; track item) {
          <div class="cell-line">{{ item }}</div>
        }
      }
      @case ('ranked') {
        @for (item of cell.items; track item.rank) {
          <div class="cell-line"><span class="rank-badge">{{ item.rank }}</span>{{ item.label }}</div>
        }
      }
      @case ('distribution') {
        @for (item of cell.items; track item.label) {
          <div class="cell-line cell-line-dist"><span class="cell-label">{{ item.label }}</span>@if (item.count != null) {<span class="cell-count">（{{ item.count }}）</span>}</div>
        }
      }
    }
  </ng-template>

  <div class="table-card report-card" [class.wide-answer]="(report.viewType === 'manager' || report.showOrgComparison) && showOtherOrg" [class.member-view]="report.viewType === 'member'">
    <h3 class="section-title">{{ report.viewType === 'member' ? 'あなたについて' : '担当者について' }}　（本人の状態）</h3>
    <table class="report-table">
      <thead>
        <tr>
          <th class="col-content">アンケート内容</th>
          <th class="col-answer col-answer-you">{{ report.viewType === 'member' ? 'あなたの回答' : '担当' }}</th>
          <th class="col-answer">自組織</th>
          @if ((report.viewType === 'manager' || report.showOrgComparison) && showOtherOrg) {
            <th class="col-answer">他組織</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of selfRows; track row.no) {
          <tr [class.scale-row]="row.no <= 12">
            <td class="col-content">
              <!-- 設問文が折り返しても、2行目以降が設問番号の下に回り込まないようにする -->
              <div class="q-text">
                <span class="q-no">{{ row.displayNo }}</span>
                <div class="q-body">
                  {{ row.text }}
                  @if (row.topFive) {
                    <div class="top5-note">※ Top5を表示</div>
                  }
                </div>
              </div>
            </td>
            <td class="col-answer col-answer-you" [attr.data-label]="report.viewType === 'member' ? 'あなたの回答' : '担当'">
              <ng-container [ngTemplateOutlet]="cellTpl" [ngTemplateOutletContext]="{ cell: row.you }"></ng-container>
            </td>
            <td class="col-answer" data-label="自組織"><ng-container [ngTemplateOutlet]="cellTpl" [ngTemplateOutletContext]="{ cell: row.org }"></ng-container></td>
            @if ((report.viewType === 'manager' || report.showOrgComparison) && showOtherOrg) {
              <td class="col-answer" data-label="他組織">
                <ng-container [ngTemplateOutlet]="cellTpl" [ngTemplateOutletContext]="{ cell: row.otherOrg }"></ng-container>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="table-card report-card" [class.wide-answer]="(report.viewType === 'manager' || report.showOrgComparison) && showOtherOrg" [class.member-view]="report.viewType === 'member'">
    <h3 class="section-title">職場/店舗について　（職場/店舗の状態）</h3>
    <table class="report-table">
      <thead>
        <tr>
          <th class="col-content">アンケート内容</th>
          <th class="col-answer col-answer-you">{{ report.viewType === 'member' ? 'あなたの回答' : '担当' }}</th>
          <th class="col-answer">自組織</th>
          @if ((report.viewType === 'manager' || report.showOrgComparison) && showOtherOrg) {
            <th class="col-answer">他組織</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of workplaceRows; track row.no) {
          <tr [class.scale-row]="row.no <= 12">
            <td class="col-content">
              <!-- 設問文が折り返しても、2行目以降が設問番号の下に回り込まないようにする -->
              <div class="q-text">
                <span class="q-no">{{ row.displayNo }}</span>
                <div class="q-body">
                  {{ row.text }}
                  @if (row.topFive) {
                    <div class="top5-note">※ Top5を表示</div>
                  }
                </div>
              </div>
            </td>
            <td class="col-answer col-answer-you" [attr.data-label]="report.viewType === 'member' ? 'あなたの回答' : '担当'">
              <ng-container [ngTemplateOutlet]="cellTpl" [ngTemplateOutletContext]="{ cell: row.you }"></ng-container>
            </td>
            <td class="col-answer" data-label="自組織"><ng-container [ngTemplateOutlet]="cellTpl" [ngTemplateOutletContext]="{ cell: row.org }"></ng-container></td>
            @if ((report.viewType === 'manager' || report.showOrgComparison) && showOtherOrg) {
              <td class="col-answer" data-label="他組織">
                <ng-container [ngTemplateOutlet]="cellTpl" [ngTemplateOutletContext]="{ cell: row.otherOrg }"></ng-container>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="back-area" [class.wide-answer]="(report.viewType === 'manager' || report.showOrgComparison) && showOtherOrg">
    <button type="button" class="back-button" (click)="onBack()">一覧に戻る</button>
  </div>
}
